import { Tooltip } from "antd";
import { serverImgFullPath } from "../../../utils/Common";

export default function OrderViewGridFoodItem({ food }) {
  function truncateText(text, size) {
    return text.length > size ? text.slice(0, size) + "..." : text;
  }
  
  return (
    <Tooltip title={food.name} color="#000000" styles={{ color: '#572D86' }}>
      <div className="w-full h-full flex flex-col overflow-hidden cursor-pointer">
        <div className="w-full h-[91px]">
          <img
            src={serverImgFullPath(food.image, '/images/icons/no-pic-icon.svg')}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/favicon.png";
            }}
            alt={food.name}
            className="w-full h-full object-cover rounded-t-[8px]"
          />
        </div>
        <p className="text-[#572D86] text-[12px] font-medium text-center mb-2 mt-2 px-[5px] leading-[18px] line-clamp-2">
          {food.name}
        </p>
      </div>
    </Tooltip>
  );
}
